import supabase from '../../../../ofindo/database/supabaseClient'

// Server should return AuthModel
export function login(email: string, password: string) {
  return supabase.auth.signInWithPassword({
    email: email,
    password: password,
  })
}

// Server should return AuthModel
export async function register(
  first_name: string,
  last_name: string,
  email: string,
  password: string,  
) {
  return await supabase.auth.signUp({
    email: email,
    password: password,
    options: {
      emailRedirectTo: 'http://localhost:3011/auth/confirm',
      data: {
        user_access: 'partnerportal',
        first_name: first_name,
        last_name: last_name,
      }
    }
  })
}


export async function requestPassword(email: string) {
  return await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: 'http://localhost:3011/auth/confirm',
  })
}

export async function resetPassword(password: string) {
  return await supabase.auth.updateUser({ password: password })
}


/*export function requestPassword(email: string) {
   return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  }) 
}*/

// Logout
export function authLogout() {
  return supabase.auth.signOut()
}

export function getUserById(userId: string) {
  return supabase
  .from('accounts')
  .select(`first_name, last_name, postal_code, avatar_url, language, user_access`)
  .eq('id', userId)
  .single()
}